import { TargetIcon, TrophyLineIcon } from 'assets/icons';
import useText from 'hooks/useText';
import StatsCard, { CardAside } from './StatsCard';
import { FEELINGS } from './statsFormat';

// A scale of a review, from 1 to 5, as five dots.
export const Dots = ({ value }) => {
  const { text } = useText('stats');
  return (
    <span
      className="flex shrink-0 gap-1"
      role="img"
      aria-label={text('dots', { value })}
    >
      {[1, 2, 3, 4, 5].map((index) => (
        <span
          key={index}
          className={`size-2.5 rounded-full ${index <= value ? 'bg-gray-900' : 'bg-gray-200'}`}
        />
      ))}
    </span>
  );
};

// The victory or the challenge of a review, on a grey line.
export const ReviewLine = ({ icon: Icon, children }) => (
  <p className="flex items-center gap-2 rounded-[10px] bg-gray-100 px-3 py-2.5 text-xs font-medium leading-4 text-gray-900">
    <span className="flex shrink-0">
      <Icon wh={16} color="currentColor" />
    </span>
    {children}
  </p>
);

/**
 * « Mon ressenti »: the last review (a week) or the average of the reviews
 * of the period, its victory and its challenge when there is one person.
 */
const FeelingCard = ({ title, aside, feeling, empty }) => {
  const { text } = useText('stats');
  return (
    <StatsCard
      title={title}
      aside={aside && <CardAside>{aside}</CardAside>}
      className="w-full shrink-0 self-stretch lg:w-[344px]"
    >
      {!feeling && <p className="text-sm leading-5 text-gray-600">{empty}</p>}
      {feeling && (
        <>
          {FEELINGS.map((key) => (
            <div key={key} className="flex items-center gap-2">
              <p className="flex-1 text-sm leading-5 text-gray-600">
                {text(`feeling_${key}`)}
              </p>
              <Dots value={feeling[key]} />
            </div>
          ))}
          {feeling.victory && (
            <ReviewLine icon={TrophyLineIcon}>{feeling.victory}</ReviewLine>
          )}
          {feeling.challenge && (
            <ReviewLine icon={TargetIcon}>{feeling.challenge}</ReviewLine>
          )}
        </>
      )}
    </StatsCard>
  );
};

export default FeelingCard;
